import * as pubnubNotificationService from '@/services/pubnubNotificationService';
import { getGlobalNotificationClientType, getPubnubNotificationsSubscribeKey } from '@/redux/modules/config';
import { bindActionCreators } from 'redux';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getSessionId } from '@/redux/modules/user';
import isEqual from 'react-fast-compare';
import { pubnubGlobalNotificationsOnMessageReceived } from '@/redux/modules/globalNotification';

type OwnProps = {};

const mapStateToProps = (state) => {
    const globalNotificationClientType = getGlobalNotificationClientType(state);
    const subscribeKey = getPubnubNotificationsSubscribeKey(state);
    const sessionId = getSessionId();

    return {
        channel: `Notification.global.${globalNotificationClientType}`,
        sessionId,
        subscribeKey,
    };
};

const mapDispatchToProps = (dispatch: Function) =>
    bindActionCreators(
        {
            onMessage: pubnubGlobalNotificationsOnMessageReceived,
        },
        // @ts-ignore
        dispatch
    );

type ReduxProps = {
    channel: string;
    sessionId: string;
    subscribeKey: string;
};
type ReduxActions = {
    onMessage: Function;
};

type Props = OwnProps & ReduxProps & ReduxActions;

type State = {
    pubnubChannel: any;
};

class PubnubGlobalNotificationContainer extends Component<Props, State> {
    static defaultProps = {
        subscribeKey: '',
    };

    state = {
        pubnubChannel: null,
    };

    componentDidMount() {
        this.connectToPubnub();
    }

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    componentDidUpdate() {
        if (!this.state.pubnubChannel) {
            this.connectToPubnub();
        }
    }

    componentWillUnmount() {
        const { pubnubChannel } = this.state;
        if (pubnubChannel) {
            pubnubChannel.unsubscribe();
            this.setState({ pubnubChannel: null });
        }
    }

    connectToPubnub = async () => {
        const { channel, onMessage, sessionId, subscribeKey } = this.props;
        const { pubnubChannel } = this.state;

        if (pubnubChannel) {
            pubnubChannel.unsubscribe();
        }
        await pubnubNotificationService.connect(sessionId, subscribeKey);
        const newChannel = await pubnubNotificationService.subscribe(channel, onMessage, sessionId, subscribeKey);

        this.setState({ pubnubChannel: newChannel });
    };

    render() {
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PubnubGlobalNotificationContainer);
